import {Divider, Form, Modal, Select, Tabs} from "antd";
import React from "react";
import {SelectGenerator} from "../../../../data_selectors/SelectGenerator";
import {SelectBillTo} from "../../../../data_selectors/SelectBillTo";
import {SelectFacility} from "../../../../data_selectors/SelectFacility";
import {SelectTransporter} from "../../../../data_selectors/SelectTransporter";
import {WorkOrderList} from "../../../../models/workorder";
import Button from "../../../../../node_modules/antd/es/button/button";

const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const Option = Select.Option;

export class AdvancedSearchWorkOrderForm extends React.Component {

  state = {
    advanceVisible: false,
    confirmLoading: false
  };

  advanceMdlVisible = (visible) => {
    this.setState({advanceVisible: visible})
  };

  handleSelect = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({confirmLoading: true});
        let params = {};
        Object.keys(values).forEach(item => {
          if (values[item])
            params[item] = values[item]
        });
        WorkOrderList({...params, ...this.props.params})
          .then(response => {
            this.advanceMdlVisible(false);
            this.props.advanceFilter(response, params);
            this.setState({confirmLoading: false})
          })
      }
    })
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {confirmLoading} = this.state;
    return (
      <React.Fragment>
        <button onClick={() => this.advanceMdlVisible(true)} className="advance-search-btn">Advance</button>
        <Button onClick={() => this.props.resetFilter()} className="refresh-btn"><i className="fa fa-repeat"/> </Button>
        <Modal title="Advanced Search" confirmLoading={confirmLoading} onOk={this.handleSelect}
               visible={this.state.advanceVisible} onCancel={() => this.advanceMdlVisible(false)} okText="Search"
               className="advance-report" width={"60%"} destroyOnClose={true}>
          <div className="row proposal-search-tabs">
            <div className="col-12">
              <Divider>Search By</Divider>
            </div>
            <div className="col-sm-6 col-12">
              <FormItem label="Generator">
                {getFieldDecorator('generator__id')(<SelectGenerator/>)}
              </FormItem>
            </div>
            <div className="col-sm-6 col-12">
              <FormItem label="Bill To">
                {getFieldDecorator('bill_to__id')(<SelectBillTo/>)}
              </FormItem>
            </div>
            <div className="col-sm-6 col-12">
              <FormItem label="Facility">
                {getFieldDecorator('service__facility__id')(<SelectFacility/>)}
              </FormItem>
            </div>
            <div className="col-sm-6 col-12">
              <FormItem label="Transporter">
                {getFieldDecorator('service__transporter__id')(<SelectTransporter/>)}
              </FormItem>
            </div>
            <div className="col-sm-6 col-12">
              <FormItem label="WorkOrder Type">
                {getFieldDecorator('workorder_type')(
                  <Select placeholder="Select WorkOrder Type"
                          style={{width: "100%"}}>
                    <Option key='call_in'>CALL IN</Option>
                    <Option key="hotsheet">HOTSHEET</Option>
                  </Select>)}
              </FormItem>
            </div>
            <div className="col-sm-6 col-12">
              <FormItem label="Waste Stream Code">
                {getFieldDecorator('service__waste_stream__waste_stream__code')(
                  <Select showSearch placeholder="Waste Stream Code" optionFilterProp="children" style={{width: "100%"}}
                          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  <Option key="BIO">BIO</Option>
                    <Option key="C&D">C&D</Option>
                    <Option key="CONT">CONT</Option>
                    <Option key="DOS">DOS</Option>
                    <Option key="EQR">EQR</Option>
                    <Option key="FILTER BIN">FILTER BIN</Option>
                    <Option key="FLEX">FLEX</Option>
                    <Option key="FLEX HOSE">FLEX HOSE</Option>
                    <Option key="FO">FO</Option>
                    <Option key="GLY">GLY</Option>
                    <Option key="GW">GW</Option>
                    <Option key="HAZ">HAZ</Option>
                    <Option key="HAZ 2.2">HAZ 2.2</Option>
                    <Option key="HWL">HWL</Option>
                    <Option key="HWS">HWS</Option>
                    <Option key="JET">JET</Option>
                    <Option key="JETF">JETF</Option>
                    <Option key="LAB ANALY">LAB ANALY</Option>
                    <Option key="LED">LED</Option>
                    <Option key="LIN">LIN</Option>
                    <Option key="MAT">MAT</Option>
                    <Option key="MED">MED</Option>
                    <Option key="MW">MW</Option>
                    <Option key="N001">N001</Option>
                    <Option key="N002">N002</Option>
                    <Option key="N003">N003</Option>
                    <Option key="N004">N004</Option>
                    <Option key="N006">N006</Option>
                    <Option key="N007">N007</Option>
                    <Option key="N011">N011</Option>
                    <Option key="N013">N013</Option>
                    <Option key="N017">N017</Option>
                    <Option key="N018">N018</Option>
                    <Option key="N098">N098</Option>
                    <Option key="N099">N099</Option>
                    <Option key="N324">N324</Option>
                    <Option key="N324OIL">N324OIL</Option>
                    <Option key="N816">N816</Option>
                    <Option key="N855">N855</Option>
                    <Option key="N855-BIN">N855-BIN</Option>
                    <Option key="N855PK">N855PK</Option>
                    <Option key="N864">N864</Option>
                    <Option key="N877">N877</Option>
                    <Option key="N903">N903</Option>
                    <Option key="NA1993">NA1993</Option>
                    <Option key="ND">ND</Option>
                    <Option key="NH5">NH5</Option>
                    <Option key="NONHAZ L">NONHAZ L</Option>
                    <Option key="NONHAZ S">NONHAZ S</Option>
                    <Option key="NONREG L">NONREG L</Option>
                    <Option key="NONREG S">NONREG S</Option>
                    <Option key="NP">NP</Option>
                    <Option key="NPU">NPU</Option>
                    <Option key="NWWF">NWWF</Option>
                    <Option key="OVERPACK">OVERPACK</Option>
                    <Option key="PCBDIE">PCBDIE</Option>
                    <Option key="PCFO">PCFO</Option>
                    <Option key="PLAS">PLAS</Option>
                    <Option key="POTW">POTW</Option>
                    <Option key="PRGLY">PRGLY</Option>
                    <Option key="RCRA EMPTY">RCRA EMPTY</Option>
                    <Option key="REC">REC</Option>
                    <Option key="RWWT">RWWT</Option>
                    <Option key="SA">SA</Option>
                    <Option key="SAWD">SAWD</Option>
                    <Option key="SPILL DECK">SPILL DECK</Option>
                    <Option key="SRP">SRP</Option>
                    <Option key="STAGE">STAGE</Option>
                    <Option key="TANK - F">TANK - F</Option>
                    <Option key="TANK - S">TANK - S</Option>
                    <Option key="TRANSFER">TRANSFER</Option>
                    <Option key="TRANSFORMER">TRANSFORMER</Option>
                    <Option key="TSCA">TSCA</Option>
                    <Option key="UD">UD</Option>
                    <Option key="UN1203">UN1203</Option>
                    <Option key="UW">UW</Option>
                    <Option key="WWF">WWF</Option>
                    <Option key="WWF PUMP">WWF PUMP</Option>
                    <Option key="WWT">WWT</Option>
                  </Select>)}
              </FormItem>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

export const AdvancedSearchWorkOrder = Form.create()(AdvancedSearchWorkOrderForm);


// WEBPACK FOOTER //
// ./src/pages/tracks/workorder/popups/AdvanceSearchWorkOrder.jsx